import { render, staticRenderFns } from "./SubscriptionLicencesList.vue?vue&type=template&id=867291f4"
import script from "./SubscriptionLicencesList.vue?vue&type=script&lang=js"
export * from "./SubscriptionLicencesList.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionLicencesList.vue?vue&type=style&index=0&id=867291f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports